// The page's one Web Audio context (issues #3718, #3747): created on first use, resumed from the
// first gesture by whoever plays first, and then left running for as long as the page lives. It is
// never closed (WebKit plays quietly for the rest of the process once a page lets its audio go fully
// idle before capturing again, docs/learn/audio-research.md, 2026-09-04) and never suspended (on the
// iPhone, with a session type declared, a suspend and resume left the page's output half a second
// late for the rest of the app's life, 2026-10-02). The Player's Web Audio path and the Learn audio
// session share it, so the page audio session's rules (client/src/audio/audio_session.ts) apply to
// one context, and the soundfont is decoded on the context it is played on.
//
// It is created by whoever plays first, inside that gesture and after the page audio session has
// been declared, which is where the measurements were made; nothing creates it at startup (the
// soundfont decodes on a context of its own). Who resumes it is the caller's business: the Player
// and the Learn session each call resume() synchronously inside the tap that starts them, which is
// where iOS requires it; on a context already running that does nothing and costs nothing.

import { createAudioContext } from '../player/instrument.ts';

let pageAudioContext: AudioContext | undefined;

export function getPageAudioContext(): AudioContext {
  pageAudioContext ??= createAudioContext({ latencyHint: 'interactive' });
  return pageAudioContext;
}
